import { FormGroup } from '@angular/forms';
import FileSaver from 'file-saver';
import { FormValidators } from './form-validators/form-validators';

export class Utils {

    static noImage = 'assets/images/no_img.png';

    static convertThumbnail(url: string, size = 't') {
        return `https://api.pagepeeker.com/v2/thumbs.php?size=${size}&url=${url}`;
    }

    static getError(errors: any) {
        return Object.values(errors);
    }

    static openImage(src: any) {
        const modal = document.getElementById('imageModal');
        const modalImg: any = document.getElementById("imgContent");
        modal.style.display = "block";
        modalImg.src = src?.changingThisBreaksApplicationSecurity || src;
    }

    static closeImage() {
        const modal = document.getElementById('imageModal');
        modal.style.display = "none";
    }

    static closeVideo() {
        const modalVideo: any = document.getElementById("videoContent");
        modalVideo.pause();
        modalVideo.currentTime = 0;
        const modal = document.getElementById('videoModal');
        modal.style.display = "none";
    }

    static openVideo(src: any) {
        const modal = document.getElementById('videoModal');
        const modalVideo: any = document.getElementById("videoContent");
        modal.style.display = "block";
        modalVideo.src = src?.changingThisBreaksApplicationSecurity || src;
        modalVideo.play();
    }

    static isOtherType(contentType: string) {
        // To check the content type other then image,audio and video
        if (contentType.includes("audio") || contentType.includes("video") || contentType.includes("image")) {
            return false;
        } else { return true; }
    }

    static downloadFileByUrl(url: string, fileName?: string) {
        fetch(url)
        .then(response => {
            if(!response.ok){
                throw new Error(`HTTP error, status: ${response.status}`);
            }
            return response.blob()
        })
        .then(data => {
            FileSaver.saveAs(data, fileName ?? `attachment.${data.type.substring(data.type.indexOf('/')+1)}`)
        })
        .catch(err => {
            console.error(err);
        })
    }

    static convertBase64ToFile(file: any) {
        return URL.createObjectURL(this.decodeBase64String(file));
    }

    static downloadFile(file: any) {
        FileSaver.saveAs(this.decodeBase64String(file), `${file.fileName}.${file.suffix}`);
    }

    static decodeBase64String(file: { base64File: string, mediaType: string, fileName: string }) {
        // decode item
        const byteCharacters = atob(file.base64File);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
            const slice = byteCharacters.slice(offset, offset + 512);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        // make base64 item to file
        return new File(byteArrays, file.fileName, { type: file.mediaType });
    }

    static toMidnight(input: Date) {

        const date = new Date(input);

        const day = date.getDate();
        const month = date.getMonth();
        const year = date.getFullYear();

        const newDate = new Date(year, day, month);
        const midnightDate = newDate.setHours(0, 0, 0, 0);
        return new Date(midnightDate).toISOString();
    }

    static getErrorMessage(controlName: string, form: FormGroup) {
        const control = form.get(controlName);
        const errorMessages = [
            { code: "PasswordTooShort", description: "Password requires at least '{0}' characters" },
            { code: "PasswordRequiresDigit", description: "Password requires at least 1 numeric character" },
            { code: "PasswordRequiresLower", description: "Password requires at least 1 lower case character" },
            { code: "PasswordRequiresUpper", description: "Password requires at least 1 upper case character" },
            { code: "PasswordRequiresNonAlphanumeric", description: "Password requires at least 1 symbol" }
        ];
        const validationMessage = FormValidators.CustomPasswordValidator.GetErrorMessage(control, errorMessages);

        if (control.hasError("required") && controlName == "newPassword") {
            return validationMessage.replace("{0}", "New Password");
        } else if (control.hasError("required") && controlName == "password") {
            return validationMessage.replace("{0}", "Password");
        }

        return validationMessage;
    }

    
    static initSearch() {
        $('#searchBarTitle').hide();
        $('#searchBar').show();
    }

    static closeSearchBar() {
        $('#searchBar').hide();
        $('#searchBarTitle').show();
    }
}
